import React, {Component} from 'react'
import brandLogo from 'images/clarivor-p-500.png'
import {Link} from 'react-router-dom'
// import lk from "*.module.css"
import {AppContext} from "../contexts"
import SignInModal from "./SignInModal"
import {mixpanel} from "../../services/mixpanel"
import {globalAuthManager} from "../../services/GlobalServices"
import {User} from "react-feather"

// import lk from 'lk/dist/assets/css/theme.module.css'

// not using module:
import {mapClasses} from "../../util/cssModule"
// const mapClasses = (module, classstr) => module == null ? classstr : module[classstr]
// const mapClassesLK = (classname) => lk[classname]

const navBarToggleStyle = {}
const lkNavLinkStyle = {}

const navBarStyle = {
    paddingRight: '1rem',
    paddingLeft: '1rem',
    paddingTop: '1.25rem',
    paddingBottom: '1.25rem',
    border: 'none'
}

const navBarBrandStyle = {
    // paddingTop: '.15rem',
    // paddingBottom: '.15rem',
    // marginRight: '0',
}


const navBarButtonStyle = {
    paddingTop: '0.5625rem',
    paddingRight: '1rem',
    paddingBottom: '0.5625rem',
    paddingLeft: '1rem',
    fontWeight: '400',
    fontFamily: 'Arial, Helvetica, sans-serif',
    fontSize: '1.0625rem',
}
//
// const navBarToggleStyle = {
//     color: '#506690',
//     borderColor: 'transparent'
// }

// const lkNavLinkStyle = {
//     margin: '0px',
//     fontFamily: 'HKGroteskPro',
//     fontSize: '1.0625rem',
//     lineHeight: '1.6',
//     textAlign: 'left',
//     backgroundColor: 'transparent',
//     paddingLeft: '1.5rem',
//     paddingRight: '1.5rem',
//     fontWeight: '600',
// }


class SignInButton extends Component {

    render() {

        return (
            <button type='button' className={mapClasses(null, "navbar-btn btn btn-sm btn-outline-dark lift ml-auto")}
                    data-toggle="modal"
                    data-target="#modalSigninVertical"
                    style={navBarButtonStyle}>
                Sign in
            </button>
        )
    }

}

function UserMenu(props) {
    const appContext = React.useContext(AppContext)

    const logout = () => {
        const sourcePath = props.location ? props.location.pathname : ''
        mixpanel.track('Signed Out', {Source: sourcePath})
        globalAuthManager.logout()
    }

    return (
        <div className="nav-item dropdown ml-auto">
            <button
                type='button'
                className={mapClasses(null, "navbar-btn btn btn-sm btn-light dropdown-toggle d-flex align-items-center")}
                style={navBarButtonStyle}
                id="navbarInvestmentUserMenu"
                data-toggle="dropdown"
                aria-haspopup="true"
                aria-expanded="false"
                aria-label={"User menu" + (appContext.username ? " for " + appContext.username : "")}
                title={appContext.username || "User menu"}
            >
                <User size={18}/>
            </button>
            <div className="dropdown-menu dropdown-menu-right dropdown-menu-xs" aria-labelledby="navbarInvestmentUserMenu">
                <Link className="dropdown-item mx-0" style={{maxWidth: '100%'}} to="/account">
                    Profile
                </Link>
                <button
                    type="button"
                    className="dropdown-item mx-0"
                    style={{maxWidth: '100%'}}
                    onClick={logout}
                >
                    Sign-out
                </button>
            </div>
        </div>
    )
}


function UserOrSignInButton(props) {
    const appContext = React.useContext(AppContext)

    switch (appContext.isLoggedIn) {
        case false:
            return <SignInButton {...props} />
        case true:
            return <UserMenu {...props} />
        default:
            return (
                <button type='button'
                        className={mapClasses(null, "navbar-btn btn btn-sm btn-light ml-auto text-light")}
                        style={navBarButtonStyle}>
                    Waiting
                </button>
            )
    }
}

export default function NavBarInvestmentApp(props) {

    return (
        <nav className="navbar navbar-expand-md navbar-light mb-2  d-flex" style={navBarStyle}>
            <div className="container-fluid">


                {/* Brand  */}
                <span className={mapClasses(null, "navbar-brand")} style={navBarBrandStyle}>
                        <Link to='/home'>
                            <img src={brandLogo} style={{width: 'auto', maxHeight: '37.5px'}}
                                 className="navbar-brand-img"
                                 alt="..."/>
                        </Link>
                    </span>


                {/* Toggler  */}
                <button className="navbar-toggler collapsed" type="button" data-toggle="collapse"
                        data-target="#navbarSupportedContent" aria-controls="navbarSupportedContent"
                        aria-expanded="false" aria-label="Toggle navigation">
                    <span className="navbar-toggler-icon"></span>
                </button>

                <div className="navbar-collapse collapse ml-auto" id="navbarSupportedContent" style={{}}>

                    <ul className="navbar-nav ml-auto mr-3">
                        <li className="nav-item">
                            <Link to={{pathname: '/contact', state: {topic: 'technical-support'}}}
                                  target='_blank' className="nav-link">
                                <button className='btn btn-rounded-circle btn-outline-warning'>?</button>
                            </Link>
                        </li>
                    </ul>
                    <UserOrSignInButton/>
                </div>

            </div>
        </nav>
    )
}
